package com.parmartechnologies.communication.core.viewModel


import androidx.compose.runtime.Stable
import com.parmartechnologies.communication.core.handler.AuthHandler
import com.parmartechnologies.core.feature.auth.model.FriendlyUser
import com.parmartechnologies.core.feature.auth.model.Language
import com.parmartechnologies.core.feature.auth.network.AuthRequest
import com.parmartechnologies.core.feature.auth.network.CheckAccountRequest
import com.parmartechnologies.core.feature.auth.network.GetUserRequest
import com.parmartechnologies.core.feature.auth.network.LanguageRequest
import com.parmartechnologies.core.feature.auth.network.SendOTPRequest
import com.parmartechnologies.core.feature.auth.network.SetPasswordRequest
import com.parmartechnologies.core.feature.locale.Localization
import com.parmartechnologies.communication.core.network.AuthNetwork
import com.parmartechnologies.core.app.AppViewModel
import com.parmartechnologies.core.country.CountryCode
import com.parmartechnologies.storage.constant.KeyConstant
import com.parmartechnologies.storage.store.UserDefaults
import com.parmartechnologies.storage.table.user.UserDatabaseTable
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlin.time.ExperimentalTime

@Stable
class AuthViewModel : AppViewModel() {
    val repository = AuthHandler.shared().repository

    init {
        AuthHandler.shared().checkIfLoggedIn()
        loadLanguage()
    }

    val selectedLanguage = repository.selectedLanguage
    val tempAuthUser: StateFlow<FriendlyUser>
        get() = repository.tempAuthLiveData

    private val allAuthLiveData: MutableStateFlow<ArrayList<FriendlyUser>> =
        MutableStateFlow(arrayListOf())
    val allAuth: StateFlow<ArrayList<FriendlyUser>>
        get() = allAuthLiveData

    val profiles: StateFlow<List<FriendlyUser>>
        get() = repository.profiles

    val authUser: StateFlow<FriendlyUser>
        get() = repository.authUser

    val isLoggedIn: StateFlow<Boolean>
        get() = repository.isLoggedIn

    val isAuthContainerVisible: StateFlow<Boolean>
        get() = repository.isAuthContainerVisible

    val otp: StateFlow<String>
        get() = repository.otpState

    private val passwordState: MutableStateFlow<String> = MutableStateFlow("")
    val password: StateFlow<String>
        get() = passwordState

    val mobileNumber = repository.mobileNumber

    var goToRegister: (() -> Unit)? = null
    var goToOtp: (() -> Unit)? = null
    var goToSetMPin: (() -> Unit)? = null
    var goToLoginWithMPin: (() -> Unit)? = null
    var goToHome: (() -> Unit)? = null
    var goBack: (() -> Unit)? = null
    fun showAuthContainer(){
        scope.launch {
            repository.isAuthContainerVisibleState.emit(true)
        }
    }
    fun hideAuthContainer(){
        scope.launch {
            repository.isAuthContainerVisibleState.emit(false)
        }
    }
    fun setMobileNumber(mobile: String) {
        scope.launch {
            repository.mobileNumberState.emit(mobile)
        }
    }

    fun loadLanguage() {
//        val selectedLanguage = UserDefaults.retrieve(KeyConstant.language)
//        val localizationStringFromStorage = UserDefaults.retrieve(KeyConstant.localization)
//        if (selectedLanguage.isNotEmpty()) {
//            val language: Language = Json.decodeFromString(selectedLanguage)
//            CoroutineScope(Job() + Dispatchers.Main).launch {
//                repository.selectedLanguageState.emit(language)
//            }
//            if (localizationStringFromStorage.isNotEmpty()) {
//                val localizationFromStorage: Localization =
//                    json.decodeFromString(localizationStringFromStorage)
//                CoroutineScope(Job() + Dispatchers.Main).launch {
//                    repository.localizationState.emit(localizationFromStorage)
//                }
//            } else {
//                downloadLanguage(language.code)
//            }
//        } else {
//            CoroutineScope(Job() + Dispatchers.Main).launch {
//                repository.selectedLanguageState.emit(Language(code = "en", "English"))
//                downloadLanguage("en")
//            }
//        }
    }

    fun updateLanguage(language: Language?) {
        if (language != null) {
            val creds : String = jsonDecoder.encodeToString(Language.serializer(),language)
            UserDefaults.shared().store(KeyConstant.language, creds)
            CoroutineScope(Job() + Dispatchers.Main).launch {
                repository.selectedLanguageState.emit(language)
            }
            downloadLanguage(language.code)
        }
    }


    @OptIn(ExperimentalTime::class)
    fun logout() {
        UserDefaults.shared().remove(KeyConstant.userCredentials)
        UserDefaults.shared().remove(KeyConstant.membershipDetails)
        CoroutineScope(Job() + Dispatchers.Main).launch {
//            CustomerHandler.shared().repository.customerState.emit(null)
            repository.tempAuthLiveData.emit(FriendlyUser())
            repository.authLiveData.emit(FriendlyUser())
        }
        AuthHandler.shared().checkIfLoggedIn()
    }

    fun sendOTP(mobile: String, diaCode: String) {
        val request = SendOTPRequest(mobile, diaCode)
        startLoading()
        scope.launch {
            AuthNetwork.shared().sendOTP(request) {
                stopLoading()
                if (it?.payload?.otp != null && it.payload!!.otp.length >= 6) {
                    scope.launch {
                        repository.otpState.emit(it.payload!!.otp)
                    }
                } else if (it?.message != null) {
//                    AlertHandler.shared().showAlert("Oops", it.message)
                }
            }
        }
    }

    fun checkAccount(mobile: String, diaCode: String,callback:(String?)-> Unit = {}) {
        val request = CheckAccountRequest(mobile, diaCode,"fd")
        scope.launch {
            AuthNetwork.shared().checkAccount(request) {result,response->
                callback(response)
                stopLoading()
                if (result?.payload?.Password != null && result.payload!!.Password.length >= 6) {
                    mainScope.launch {
                        repository.tempAuthLiveData.emit(result.payload!!)
                        passwordState.emit(result.payload!!.Password)
                        goToLoginWithMPin?.let { it1 -> it1() }
                    }
                } else if (result?.payload?.Name.isNullOrEmpty()) {
                    sendOTP(mobile, diaCode)
                    mainScope.launch {
                        goToOtp?.let { it1 -> it1() }
                    }
                } else {
//                    scope.launch {
//                        repository.tempAuthLiveData.emit(it!!.payload!!)
//                    }
//                    sendOTP(mobile, diaCode)
//                    goToOtp?.let { it1 -> it1() }
                }
            }
        }
    }

    fun setPassword(UserID: String, password: String) {
        startLoading()
        val request = SetPasswordRequest(UserID, password)
        scope.launch {
            AuthNetwork.shared().setPassword(request) {
                stopLoading()
                if (it?.status == "SUCCESS") {
                    val creds = tempAuthUser.value
                    creds.Password = password
                    UserDefaults.shared().storeCredentials(jsonDecoder.encodeToString(FriendlyUser.serializer(),creds))
                    CoroutineScope(Job() + Dispatchers.Main).launch {
                        repository.authLiveData.emit(creds)
                        goToHome?.let { it1 -> it1() }
                    }
                }
            }
        }
    }

    fun login(
        mobile: String,
        diaCode: CountryCode
    ) {
        startLoading()
        val request = AuthRequest(mobile, diaCode.countryPhoneCode, "")
        scope.launch {
            AuthNetwork.shared().login(request) {
                stopLoading()
                if (it?.payload?._id != null && it.payload!!._id.length >= 6) {
                    UserDefaults.shared().storeCredentials(jsonDecoder.encodeToString(FriendlyUser.serializer(),it.payload!!))
                    mainScope.launch {
                        repository.isLoggedInState.emit(true)
                        goToHome?.let { it1 -> it1() }
                    }
                } else {
                    mainScope.launch {
                        goToRegister?.let { it1 -> it1() }
                    }
                }
            }
        }
    }

    fun register(
        mobile: String,
        diaCode: String,
        name: String
    ) {
        startLoading()
        val request = AuthRequest(mobile, diaCode, name)
        scope.launch {
            AuthNetwork.shared().login(request) {
                stopLoading()
                if (it?.payload?._id != null && it.payload!!._id.length >= 6) {
                    UserDefaults.shared().storeCredentials(jsonDecoder.encodeToString(FriendlyUser.serializer(),
                        it.payload!!
                    ))
                    mainScope.launch {
                        repository.isLoggedInState.emit(true)
                        repository.tempAuthLiveData.emit(it.payload!!)
                        goToSetMPin?.let { it1 -> it1() }
                    }
                }
            }
        }
    }

    private fun downloadLanguage(
        code: String,
    ) {
//        startLoading()
        val request = LanguageRequest(code)
        scope.launch {
            AuthNetwork.shared().retrieveLanguage(request) {
//                stopLoading()
                scope.launch {
                    if (it?.payload != null) {
                        repository.localizationState.emit(it.payload!!)
                        UserDefaults.shared().store(
                            KeyConstant.localization,
                            jsonDecoder.encodeToString(Localization.serializer(),it.payload!!)
                        )
                    } else {

                    }
                }
            }
        }
    }

    fun getAllLanguageList(): ArrayList<Language> {
        var allLanguageOptions: ArrayList<Language> = arrayListOf()
        allLanguageOptions.add(Language(code = "en", "English"))
        allLanguageOptions.add(Language(code = "hi", "Hindi"))
        allLanguageOptions.add(Language(code = "bang", "Bangoli"))
        allLanguageOptions.add(Language(code = "ur", "Urdu"))
        return allLanguageOptions
    }

    fun getUserDetails(id:String,callBack:(FriendlyUser)->Unit){
        getUserDetailsFromStorage(id){user->
            if(user != null){
                callBack(user)
            }else{
                val request = GetUserRequest(id.trim())
                scope.launch {
                    AuthNetwork.shared().getUser(request) {
                        if(it?.payload?._id.isNullOrEmpty()){

                        }else{
                            UserDatabaseTable().insert(it!!.payload)
                            callBack(it.payload!!)
                        }
                    }
                }
            }
        }
    }
    private fun getUserDetailsFromStorage(id: String, callBack:(FriendlyUser?)->Unit){
        UserDatabaseTable().retrieve(id){
            if(it.isNotEmpty()){
                callBack(it.first())
            }else{
                callBack(null)
            }
        }
    }
}